/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Kód slevy je neplatný`
};

const da_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Rabatkoden er ugyldig`
};

const de_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Der Rabattcode ist ungültig`
};

const en_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `The discount code is invalid`
};

const es_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `El código promocional no es válido`
};

const fr_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Le code promo est invalide`
};

const hu_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `A promóciós kód érvénytelen`
};

const it_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Codice sconto non valido`
};

const nl_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `De kortingscode is ongeldig`
};

const pl_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Kod rabatowy jest nieprawidłowy`
};

const pt_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `O código promocional é inválido`
};

const sv_discount_code_messages_invalid = /** @type {(inputs: {}) => string} */ () => {
	return `Rabattkoden är ogiltig`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_code_messages_invalid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_code_messages_invalid(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_code_messages_invalid", locale)
	if (locale === "cs") return cs_discount_code_messages_invalid(inputs)
	if (locale === "da") return da_discount_code_messages_invalid(inputs)
	if (locale === "de") return de_discount_code_messages_invalid(inputs)
	if (locale === "en") return en_discount_code_messages_invalid(inputs)
	if (locale === "es") return es_discount_code_messages_invalid(inputs)
	if (locale === "fr") return fr_discount_code_messages_invalid(inputs)
	if (locale === "hu") return hu_discount_code_messages_invalid(inputs)
	if (locale === "it") return it_discount_code_messages_invalid(inputs)
	if (locale === "nl") return nl_discount_code_messages_invalid(inputs)
	if (locale === "pl") return pl_discount_code_messages_invalid(inputs)
	if (locale === "pt") return pt_discount_code_messages_invalid(inputs)
	return sv_discount_code_messages_invalid(inputs)
};
export { discount_code_messages_invalid as "discount_code_messages.invalid" }